import { Grid, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import { Favorite, Money, People, Shop, ShoppingBag } from "@mui/icons-material";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    BarElement,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import axios from 'axios';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSalon } from "./context/SalonContext";

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend
);

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function Home() {
    var navi = useNavigate();

    const data = {
        labels: ["01", "02", "03", "04", "05", "06", "07", "08", "09"],
        datasets: [
            {
                data: [850, 600, 500, 620, 880, 480, 900, 620, 890],
                backgroundColor: "#fff",
                borderRadius: 3,
                barThickness: 18,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: "#ffffff" },
            },
            y: {
                beginAtZero: true,
                max: 1000,
                ticks: {
                    stepSize: 200,
                    color: "white",
                },
                grid: {
                    color: "rgba(255,255,255,0.2)",
                    borderDash: [5, 5],
                },
            },
        },
        animation: {
            duration: 1300,
            easing: "ease in",
            // true:true
        },
    };


    const linedata = {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
            {
                label: "Traffic",
                data: [50, 30, 300, 220, 500, 260, 400, 230, 500],
                borderColor: "#3b82f6",
                backgroundColor: "rgba(59,130,246,0.15)",
                tension: 0.4,
                fill: true,
            },
            {
                label: 'Sales',
                data: [30, 50, 100, 200, 350, 100, 304, 170, 400],
                borderColor: '#9389FE',
                tension: .4,
                fill: true
            }
        ],
    };


    var navi = useNavigate();

    function CheckLogIn() {

        var id = localStorage.getItem('uuid');
        if (id == '') {
            navi('/')
        }

    }

    useEffect(() => {
        CheckLogIn();
    }, [])

    const [reviews, setReviews] = useState([]);

    const salonId = localStorage.getItem('uuid');
    const fetchReviews = async () => {
        try {
            const res = await axios.get(
                `http://localhost:1000/google/reviews/${salonId}`
            );

            setReviews(res.data.reviews || []);
            console.log(res.data.reviews)

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchReviews();
    }, []);

    const {salon,setsalon} = useSalon();
    var url = `http://localhost:${process.env?.PORT || 3000}/`
    function fetchSalonDetails() {
        var salonId = localStorage.getItem('uuid');
        if (!salonId) {
            alert('Invalid Id');
            return;
        }
        axios.post(url + 'getShop', {
            Id: salonId
        }).then((succ) => {
            if (succ.data?.response == 'failed') {
                alert(succ.data.reason)
            } else {
                setsalon(succ.data);
                console.log(succ.data)
            }
        })
    }

    useEffect(() => {
        fetchSalonDetails();
    }, [])

    useEffect(() => {
        console.log(salon)
    },[salon])

    return (
        <>
            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} size={{ xs: 9.6 }} p={3}>
                    <Grid container justifyContent={'space-between'}>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">Today's Sales</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>$53,000</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    $
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">Today's Users</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>3,000</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    <People />
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">New Clients</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>100</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    <Favorite />
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">New Orders</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>1,200</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    <ShoppingBag />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="admin-section-cont">
                        <div className="bar-paper shadow">
                            <div className="p-3 bar-cont">
                                <Bar data={data} className="position-relative" options={options} />
                                {/* <Bar data={data} className="position-relative" options={options} /> */}
                            </div>
                            <Typography variant="h6" className="mt-3 fw-bold">Recent Sales</Typography>
                        </div>
                        <div className="line-paper">
                            <Line data={linedata} options={{
                                responsive: true, plugins: {
                                    legend: {
                                        position: 'bottom',
                                        align: 'start',
                                        onClick: function () {

                                        }
                                    }
                                }, animation: {
                                    duration: 1000,
                                    easing: 'easeInOutBack'
                                }
                            }} />;
                        </div>
                    </div>
                </Grid>
            </Grid>

        </>
    )

}